import { t } from '@hefe/i18n';
import {
  BasketballTeamsSlice,
  BasketballTeamsSyncPracticesUntilRequest,
  ModalsSlice,
} from '@hefe/store';
import { formatDatabaseDate } from '@hefe/utils';
import { Space, Typography } from 'antd';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface SyncPracticesUntilFormProps {
  teamIds: number[];
}

export default function SyncPracticesUntilForm(
  props: SyncPracticesUntilFormProps
) {
  const dispatch = useAppDispatch();
  const onSubmit = (values: any, resetForm: any) => {
    const setLoading = ModalsSlice.modalsActions.setModalLoading;

    const submitValues: BasketballTeamsSyncPracticesUntilRequest = {
      date_till: formatDatabaseDate(values.date_till),
      team_ids: props.teamIds,
    };

    dispatch(setLoading(true));
    dispatch(
      BasketballTeamsSlice.updateBasketballTeamsSyncPracticesUntil(submitValues)
    )
      .unwrap()
      .then(() => {
        resetForm();
        dispatch(ModalsSlice.modalsActions.closeModal());
      })
      .catch(() => null)
      .finally(() => setLoading(false));
  };

  return (
    <Space direction="vertical">
      <Typography.Text>{t('practices.sync.admin.info')}</Typography.Text>
      <CustomForm
        formId="sync-practices-until-form"
        fields={[
          {
            name: 'date_till',
            label: t('till'),
            type: 'date',
            rules: [
              {
                required: true,
                type: 'date',
                message: t('form_errors.date'),
              },
            ],
          },
        ]}
        onSubmit={onSubmit}
      />
    </Space>
  );
}
